// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sip-settings h3[data-v-976b3118]{margin-bottom:6px;font-weight:bold}.sip-settings p[data-v-976b3118]{white-space:pre-line}`, "",{"version":3,"sources":["webpack://./src/components/RightSidebar/SipSettings.vue"],"names":[],"mappings":"AAEC,kCACC,iBAAA,CACA,gBAAA,CAGD,iCACC,oBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
